var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-refund-integral-audit',{ref:"table",staticClass:"pt-refund-integral-audit__withData",attrs:{"exportLoading":_vm.exportLoading,"pageSize":_vm.pageSize},on:{"exportRefund":_vm.exportRefund}})}
var staticRenderFns = []

export { render, staticRenderFns }